// extracted by css-extract-rspack-plugin
var _1 = "nUKUH2T8NhJx-T2tXPLiIQ--";
var _2 = "L771vktZiZNTL8YrlqZQFw--";
export { _1 as "header", _2 as "login" }
